import React from "react";

type TableBodyProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLTableSectionElement>,
  HTMLTableSectionElement
> & {
  children: React.ReactElement;
};

/** Renders Table body
 * @param props TableBodyProps
 */
function TableBody(props: TableBodyProps) {
  const { children } = props;
  return <tbody {...props}>{children}</tbody>;
}

export default TableBody;
